import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";

const CancelDischargeModal = ({ open, onClose, id }) => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    // const response = await generateBillingByIdApi(id, {});
    const response = {};
    setLoading(false);

    if (response.code === 200 || response.code === 201) {
      toast.success(`Discharge cancelled successfully`);
      onClose();
    } else {
      toast.error(response?.message || "Some error occurred.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", md: "700px" },
            height: "300px",
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent sx={{ display: "grid", placeItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            textAlign: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h5">Are You Sure You Want To</Typography>
            <Typography variant="h5">Cancel Discharge?</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography>Reopen The Patient's Stay In The System.</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            <Button
              variant="outlined"
              sx={{ width: "150px" }}
              onClick={onClose}
            >
              No
            </Button>
            <Button
              variant="outlined"
              sx={{ width: "150px" }}
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? <CircularProgress size={24} /> : "Yes"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelDischargeModal;
